export const navigation = [
  {
    id: "0",
    title: "Home",
    url: "/",
  },
  {
    id: "1",
    title: "Pricing",
    url: "/pricing",
  },
  {
    id: "2",
    title: "Safety",
    url: "/safety",
  },
  {
    id: "3",
    title: "Events",
    url: "/events",
  },
  {
    id: "4",
    title: "Restaurant",
    url: "/restaurant",
  },
  {
    id: "5",
    title: "Contact Us",
    url: "/contact",
  },
];

export const pricing = [
  {
    id: "0",
    title: "Trampoline Park",
    description: "Above 6 Years - Bounce into fun, where the sky's the limit!",
    price: "600-350",
    priceLabel: "1 hr / 30 min",
    features: [
      "1-hour access: 600 INR",
      "30-min access: 350 INR",
      "Grip socks included",
      "Locker access",
      "Safety briefing"
    ],
  },
  {
    id: "1",
    title: "Soft Play Area",
    description: "Below 6 Years - A world of fun, just for the little ones",
    price: "450-250",
    priceLabel: "1 hr / 30 min",
    features: [
      "1-hour access: 450 INR",
      "30-min access: 250 INR",
      "Soft slides and climbing areas",
      "Locker access",
      "Padded flooring for safety"
    ],
  },
  {
    id: "2",
    title: "Inflatable",
    description: "Jump, slide, and bounce in our inflatable zone!",
    price: "450-250",
    priceLabel: "1 hr / 30 min",
    features: [
      "1-hour access: 450 INR",
      "30-min access: 250 INR",
      "Safe inflatable structures",
      "Supervised play area",
      "Fun for all ages"
    ],
  },
  {
    id: "3",
    title: "Food & Beverages",
    description: "Refresh yourself with delicious food and drinks",
    price: "On MRP",
    priceLabel: "Per Item",
    features: [
      "Variety of snacks and meals",
      "Cold and hot beverages",
      "Fresh and hygienic",
      "Reasonable pricing",
      "Quick service"
    ],
  },
];

export const benefits = [
  {
    id: "1",
    title: "Trampoline Park",
    text: "Freestyle Jump Zones: Large open trampoline areas for free bouncing and flips.",

    iconUrl: "/assets/benefits/trampoline.svg",
    imageUrl: "https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-trampoline.avif",
    light: true,

  },
  {
    id: "2",
    title: "Bounce House",
    text: "Colorful inflatable bounce castles and jumping zones where kids can bounce, slide, and giggle endlessly in a safe, padded environment.",

    iconUrl: "/assets/benefits/Bounce.svg",
    imageUrl: "/assets/Bounce.webp",
    light: true,
  },
  {
    id: "3",
    title: "Birthday Parties",
    text: "Celebrate your special day with themed decorations, dedicated party hosts, exciting games, and a cake-cutting ceremony that creates memories to cherish forever.",

    iconUrl: "/assets/benefits/BirthdayParties.svg",
    imageUrl: "/assets/B2.png",
    light: true,
  },
  {
    id: "4",
    title: "Toddler Play Zone",
    text: "Safe and fun for little climbers, with gentle slides and soft surfaces.",

    iconUrl: "/assets/benefits/playground.svg",
    imageUrl: "https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-playground.avif",
    light: true,
  },
  {
    id: "5",
    title: "Corporate Events",
    text: "Host memorable team-building sessions, offsite meetings, and office celebrations with engaging group activities, dedicated spaces, and tailored hospitality packages.",

    iconUrl: "/assets/benefits/Corporate.svg",
    imageUrl: "/assets/corporate-events/skyville-gamezone-3897_bkvbid.webp",
    light: true,
  },
  {
    id: "6",
    title: "Skyville Bistro",
    text: "Relish a curated menu of gourmet delicacies, wood-fired pizzas, fresh desserts, and artisanal beverages in our elegant in-house restaurant — the perfect place to recharge between adventures.",

    iconUrl: "/assets/benefits/food.svg",
    imageUrl: "/assets/Flavours by Skyville.JPG.jpeg",
    light: true,
  },

];

export const socials = [
  {
    id: "0",
    title: "Instagram",
    iconUrl: "/assets/socials/instagram.svg",
    url: "https://www.instagram.com/skyvilleudaipur?utm_source=qr",
  },
  {
    id: "1",
    title: "Youtube",
    iconUrl: "/assets/socials/youtube.svg",
    url: "https://www.youtube.com/@skyvilleudaipur",
  },
  {
    id: "2",
    title: "Facebook",
    iconUrl: "/assets/socials/facebook.svg",
    url: "https://www.facebook.com/skyvilleudaipur",
  },
  {
    id: "3",
    title: "Whatsapp",
    iconUrl: "/assets/socials/WhatsappFooter.svg",
    url: "https://wa.me/9468578138",
  },
];


export const faqData = [
  {
    id: 'getting-started',
    question: 'How do I book an event at Skyville?',
    answer:
      'To book an event at Skyville, visit our "Host Events" page. You can choose from various packages tailored to your needs. Fill out the booking form, and our team will get back to you with confirmation and details.',
  },
  {
    id: 'activities-offered',
    question: 'What activities are available at Skyville?',
    answer:
      'Skyville offers a wide range of activities including arcade games, trampoline parks, bowling, and virtual reality experiences. Check our Activities page for a complete list and descriptions of each offering.',
  },
  {
    id: 'party-packages',
    question: 'What are the party packages available?',
    answer:
      'We provide customizable party packages for birthdays, corporate events, and family reunions. Each package includes options for food, activities, and decorations. Visit our Pricing page for more details.',
  },
  {
    id: 'community-engagement',
    question: 'How can I stay updated with Skyville events?',
    answer:
      'Follow us on our social media channels and subscribe to our newsletter to stay informed about upcoming events, special offers, and community activities. Join our community for exclusive updates and insights.',
  },
];

export const projects = [
  {
    title: "Inflatable Bounce House",
    description: "Jump, slide, and bounce to your heart's content! Our vibrant inflatable bounce house offers safe, high-energy fun for kids — creating unforgettable moments of laughter and adventure.",
    src: "/assets/Inflatable_Video.mp4",
    alt: "inflatable-bounce-house",
    url: "https://skyvilleudaipur.com/inflatable-bounce-house"
  },
  {
    title: "Trampoline/Soft Play",
    description: "Bounce, flip, and play in our state-of-the-art trampoline park! Younger kids can enjoy a safe and fun-filled soft play area designed just for them.",
    src: "https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-trampoline.webm",
    alt: "trampoline-soft-play",
    url: "https://skyvilleudaipur.com/trampoline-soft-play"
  },
  {
    title: "Flavours by Skyville",
    description: "Savor delicious delights at our in-house dining experience! From refreshing beverages to mouthwatering snacks and meals, Flavours by Skyville serves up tasty treats for every palate.",
    src: "/assets/Restaurant/Flavours_Video.mp4",
    alt: "flavours-by-skyville",
    url: "/restaurant"
  },
  {
    title: "Parties & Events",
    description: "Host unforgettable celebrations at Skyville! Whether it's a birthday, corporate gathering, or special event, we've got customizable packages to make your day extraordinary.",
    src: "https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-events.webm",
    alt: "parties-events",
    url: "https://skyvilleudaipur.com/parties-events"
  }
];

export const eventTypes = [
  {
    name: 'Birthday Parties',
    description: 'Unforgettable celebrations for all ages.',
    image: "https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-birthday-parties.avif",
    alt: 'gamezone'
  },
  {
    name: 'Corporate Events',
    description: 'Team building and networking in a fun environment.',
    image: "https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-corporate-events.avif",
    alt: 'gamezone'
  },
  {
    name: 'School Trips',
    description: 'Educational and entertaining outings for students.',
    image: "https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-school-trips.avif",
    alt: 'gamezone'
  },
  {
    name: 'Kitty Party',
    description: 'Create lasting memories with your loved ones.',
    image: "https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-family-reunions.avif",
    alt: 'gamezone'
  },
]

export const testimonials = [
  {
    text: "Skyville is the best place for fun in Udaipur! My kids loved the trampoline park. The safety measures are top-notch, and the staff is incredibly friendly and attentive. We've been here multiple times, and each visit has been fantastic.",
    author: "Priya Sharma",
    role: "Parent of two",
    rating: 5,
    image: "https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-t4.jpg",
    alt: "gamezone"
  },
  {
    text: "Had an amazing birthday party here. Great service and awesome vibes! The party planning team went above and beyond to make my day special. The decorations were perfect, and all my friends had a blast!",
    author: "Rahul Mehra",
    role: "Birthday Celebrant",
    rating: 5,
    image: "https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-t3.jpg",
    alt: "gamezone"
  },
  {
    text: "The VR games are out of this world. Highly recommended for gamers! The equipment is state-of-the-art, and they have the latest titles. I particularly enjoyed the multiplayer VR experiences.",
    author: "Aisha Khan",
    role: "Gaming Enthusiast",
    rating: 4,
    image: "https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-t5.jpg",
    alt: "gamezone"
  },
  {
    text: "The arcade games here are amazing! My son and I had a blast playing together. It’s a fantastic place for parents and kids to bond over fun activities. Highly recommend visiting Skyville for family time.",
    author: "Suresh Gupta",
    role: "Father of one",
    rating: 5,
    image: "https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-t2.jpg",
    alt: "gamezone"
  },
  // {
  //   text: "Absolutely loved the playground area! My niece couldn’t stop smiling the whole time. The environment is clean, safe, and perfect for kids. The staff ensures everyone has a great time.",
  //   author: "Neha Verma",
  //   role: "Aunt",
  //   rating: 4,
  //   image: "https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-t1.png",
  //   alt: "gamezone"
  // }
];

export const eventsSection = [
  {
    id: 1,
    title: "Kitty Parties",
    description: "Whether it's games, gossip, or simply unwinding with friends, we’ve got everything to make your kitty party an absolute blast! Come, celebrate, and enjoy all the fun with us! Our venue offers a vibrant and welcoming space designed for ladies who love to laugh, enjoy great company, and make unforgettable memories.",
    date: "March 15, 2024",
    time: "2:00 PM",
    location: "SKYVILLE Main Hall",
    reverse: true,
    images: [
      {
        src: '/assets/kitty-party/skyville-gamezone-k1_qdlfae.webp',
        alt: 'gamezone',
        title: 'Skyville Gamezone Adventure 1',
        description: 'A vibrant depiction of gaming fun at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Fun', 'Gaming'],
      },
      {
        src: '/assets/kitty-party/skyville-gamezone-k4_yiy5wl.webp',
        alt: 'gamezone',
        title: 'Skyville Gamezone Adventure 1',
        description: 'A vibrant depiction of gaming fun at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Fun', 'Gaming'],
      },
      {
        src: '/assets/kitty-party/skyville-gamezone-k3_al3ilm.webp',
        alt: 'gamezone',
        title: 'Skyville Gamezone Adventure 2',
        description: 'Thrilling experiences captured at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Thrill', 'Adventure'],
      },
      {
        src: '/assets/kitty-party/skyville-gamezone-k4_bzqfbi.webp',
        alt: 'gamezone',
        title: 'Skyville Gamezone Adventure 3',
        description: 'Enjoy gaming activities at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Activities', 'Gaming'],
      },
    ],
  },
  {
    id: 2,
    title: "School Trips/Picnics",
    description: "Looking for the perfect spot to host an unforgettable school picnic or outing? Our spacious and vibrant venue is ideal for students to relax, play, and explore in a safe and exciting environment. With plenty of outdoor activities, picnic areas, and tailored experiences, we ensure a fun-filled day for everyone. Make your next school outing a day to remember!",
    date: "March 20, 2024",
    time: "10:00 AM",
    location: "SKYVILLE Adventure Zone",
    images: [
      {
        src: 'https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-image13.avif',
        alt: 'gamezone',
        title: 'Skyville Gamezone Image 1',
        description: 'A fun and exciting image from Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Entertainment'],
      },
      {
        src: 'https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-image6.avif',
        alt: 'gamezone',
        title: 'Skyville Gamezone Image 2',
        description: 'Enjoyable moments captured at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Activities'],
      },
      {
        src: 'https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-image10.avif',
        alt: 'gamezone',
        title: 'Skyville Gamezone Image 3',
        description: 'Memorable experiences at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Fun'],
      },
      {
        src: 'https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-image7.avif',
        alt: 'gamezone',
        title: 'Skyville Gamezone Image 4',
        description: 'Exciting moments captured at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Entertainment'],
      },
      // {
      //   src: 'https://res.cloudinary.com/dg0kso6zc/image/upload/w_400,h_400,c_fill,q_100,g_auto/v1736701892/skyville-gamezone-image8_dcecwr.jpg',
      //   alt: 'gamezone',
      //   title: 'Skyville Gamezone Image 5',
      //   description: 'Adventure and thrill at Skyville Gamezone.',
      //   category: 'Gamezone',
      //   tags: ['Skyville', 'Gamezone', 'Adventure'],
      // },
      {
        src: 'https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-image11.avif',
        alt: 'gamezone',
        title: 'Skyville Gamezone Image 5',
        description: 'Adventure and thrill at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Adventure'],
      },
    ],
  },
  {
    id: 3,
    title: "Birthday Parties",
    description: "Celebrate your special day in style at our premium birthday venue! Whether you're planning an intimate gathering or a grand celebration, we provide the perfect space to make your birthday unforgettable. Let us help you create lasting memories with family and friends, and turn your birthday into a celebration you'll cherish forever. Make this year’s birthday your most extraordinary yet!",
    date: "March 25, 2024",
    time: "11:00 AM",
    location: "SKYVILLE Park",
    reverse: true,
    images: [
      {
        src: 'https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-image1.avif',
        alt: 'gamezone',
        title: 'Skyville Gamezone Image 8',
        description: 'Exciting adventures at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Adventure'],
      },
      {
        src: 'https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-image2.avif',
        alt: 'gamezone',
        title: 'Skyville Gamezone Image 9',
        description: 'Fun and entertainment at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Entertainment'],
      },
      {
        src: 'https://cdn.jsdelivr.net/gh/VipulSoniwork/skyville-assets@main/skyville-gamezone-image5.avif',
        alt: 'gamezone ',
        title: 'Skyville Gamezone Image 10',
        description: 'Memorable moments at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Memorable'],
      },
      {
        src: '/assets/B1.png',
        alt: 'gamezone',
        title: 'Skyville Gamezone Excitement 16',
        description: 'Top entertainment at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Gaming', 'Excitement'],
      },
      {
        src: '/assets/B2.png',
        alt: 'gamezone',
        title: 'Skyville Gamezone Excitement 4',
        description: 'Capturing the excitement at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Excitement', 'Fun'],
      },
      {
        src: '/assets/B3.png',
        alt: 'gamezone',
        title: 'Skyville Gamezone Excitement 13',
        description: 'Thrills and entertainment at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Thrills', 'Entertainment'],
      },
    ],
  },
  {
    id: 4,
    title: "Corporate Events",
    description: "Our versatile venue is the perfect setting for everything from team-building activities to conferences and networking events. We offer a range of engaging games and interactive experiences designed to foster collaboration, creativity, and team spirit. Let us help you create an experience that brings your team together and leaves a lasting impression!",
    date: "March 30, 2024",
    time: "9:00 AM",
    location: "SKYVILLE Business Center",
    images: [
      {
        src: '/assets/corporate-events/corporate-1.jpeg',
        alt: 'gamezone',
        title: 'Skyville Gamezone Thrills 5',
        description: 'Amazing moments from Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Gaming', 'Entertainment'],
      },
      {
        src: '/assets/corporate-events/corporate-2.jpeg',
        alt: 'gamezone',
        title: 'Skyville Gamezone Highlights 6',
        description: 'Top experiences captured at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Highlights', 'Fun'],
      },
      {
        src: '/assets/corporate-events/corporate-3.jpeg',
        alt: 'gamezone',
        title: 'Skyville Gamezone Fun 8',
        description: 'Fun-filled times at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Activities', 'Entertainment'],
      },
      {
        src: '/assets/corporate-events/corporate-4.jpeg',
        alt: 'gamezone',
        title: 'Skyville Gamezone Experience 10',
        description: 'Top experiences at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Entertainment', 'Thrill'],
      },
      /*
      {
        src: '/assets/corporate-events/skyville-gamezone-3904_jicyvf.webp',
        alt: 'gamezone',
        title: 'Skyville Gamezone Fun 11',
        description: 'Experience gaming fun at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Gaming', 'Adventure'],
      },
      {
        src: '/assets/corporate-events/skyville-gamezone-3844_gdrywc.webp',
        alt: 'gamezone',
        title: 'Skyville Gamezone Highlights 15',
        description: 'Unforgettable fun at Skyville Gamezone.',
        category: 'Gamezone',
        tags: ['Skyville', 'Gamezone', 'Highlights', 'Adventure'],
      },
      */
    ],
  },
];
